import React from 'react';

import Lottie, { LottieProps } from 'lottie-react-web';

import animation from './json/index.json';

type AnimationProps = Omit<LottieProps, 'options'>;

const Animation: React.VFC<AnimationProps> = ({ ...props }) => (
  <Lottie {...props} options={{ animationData: animation }} />
);

export default Animation;
